import localize from "../../../common/localize";
import { GetDateInMMDDYYYYFormat } from "../../../common/utils";

export default function BillData({ billModel }) {
  return (
    <div>
      {billModel.Billed ? (
        <div>
          <p>
            <b>{`${localize.bill_code}: `}</b>
            {`${billModel.Code}`}
          </p>
          <p>
            <b>{`${localize.bill_date}: `}</b>
            {`${GetDateInMMDDYYYYFormat(new Date(billModel.GenerationDate))}`}
          </p>

          {billModel.Observation && (
            <p>
              <b>{`${localize.observations}: `}</b>
              {`${billModel.Observation}`}
            </p>
          )}

          <p style={{ marginTop: "10px" }}>{`${localize.click_to_see}`}</p>
        </div>
      ) : (
        <div>
          <p>
            <b>{`${localize.not_billed} `}</b>
          </p>
          <p>
            <b>{`${localize.observations}: `}</b>
            {`${billModel.Observation}`}
          </p>
        </div>
      )}
    </div>
  );
}
